import { render, staticRenderFns } from "./DailyProxy.vue?vue&type=template&id=137eb84e"
import script from "./DailyProxy.vue?vue&type=script&lang=js"
export * from "./DailyProxy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports